export function validateCpfCnpj(valor) {
  const documento = String(valor).replace(/\D/g, '');

  if (documento.length === 11) {
    return validarCPF(documento);
  }

  if (documento.length === 14) {
    return validarCNPJ(documento);
  }

  return false;
}

function validarCPF(cpf) {
  cpf = cpf.replace(/\D/g, '');

  if (cpf.length !== 11) return false;

  // Evita CPFs como 000.000.000-00, 111.111.111-11...
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let soma = 0;

  // Primeiro dígito verificador
  for (let i = 0; i < 9; i++) {
    soma += Number(cpf[i]) * (10 - i);
  }

  let digito1 = (soma * 10) % 11;

  if (digito1 === 10) {
    digito1 = 0;
  }

  if (digito1 !== Number(cpf[9])) {
    return false;
  }

  soma = 0;

  // Segundo dígito verificador
  for (let i = 0; i < 10; i++) {
    soma += Number(cpf[i]) * (11 - i);
  }

  let digito2 = (soma * 10) % 11;

  if (digito2 === 10) {
    digito2 = 0;
  }

  return digito2 === Number(cpf[10]);
}

function validarCNPJ(cnpj) {
  cnpj = cnpj.replace(/\D/g, '');

  if (cnpj.length !== 14) return false;

  // Evita CNPJs como 00.000.000/0000-00...
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const calcularDigito = (base, pesos) => {
    let soma = 0;

    for (let i = 0; i < pesos.length; i++) {
      soma += Number(base[i]) * pesos[i];
    }

    const resto = soma % 11;

    return resto < 2 ? 0 : 11 - resto;
  };

  const digito1 = calcularDigito(
    cnpj.substring(0, 12),
    [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );

  if (digito1 !== Number(cnpj[12])) {
    return false;
  }

  const digito2 = calcularDigito(
    cnpj.substring(0, 13),
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );

  return digito2 === Number(cnpj[13]);
}
